module.exports = __webpack_public_path__ + "img/Ardi_NewCode.5032b4ad.png";